import { EXPORT_INCLUSION_TYPES } from "../../../components/Export/types";
import { baseExportPayload } from "../../../components/Export/utils";

export interface ExportInclusionData {
  installInclusion: EXPORT_INCLUSION_TYPES;
  faiInclusion: EXPORT_INCLUSION_TYPES;
  contractsInclusion: EXPORT_INCLUSION_TYPES;
  spendInclusion: EXPORT_INCLUSION_TYPES;
  aiSpendInclusion: EXPORT_INCLUSION_TYPES;
  installProductIds?: number[];
  faiProductIds?: number[];

  intentInclusion?: EXPORT_INCLUSION_TYPES;
  topicIds?: string[];
  intentSignalScore?: "ALL" | "HIGH" | "MEDIUM" | null;

  mentionInclusion?: EXPORT_INCLUSION_TYPES;
  timeSeriesInclusion?: EXPORT_INCLUSION_TYPES;
  mentionTimeSeriesInclusion?: EXPORT_INCLUSION_TYPES;
  relativeSpendInclusion?: EXPORT_INCLUSION_TYPES;
  generativeAIInclusion?: EXPORT_INCLUSION_TYPES;
  rowBasedSpendInclusion?: EXPORT_INCLUSION_TYPES;
}

//todo correct this once its clear
export type ExportData = typeof baseExportPayload;

//todo :  correct this once response type is fully defined

export enum ExportCategory {
  Installs = "Installs",
  Contracts = "Contracts",
  FunctionalAreaIntelligence = "Functional Area Intelligence",
  CloudMaturity = "Cloud Maturity",
  ProductsAndVendors = "Products & Vendors",
  ITSpend = "IT Spend",
  AISpend = "AI Spend",
}
export interface ExportSettingItem {
  main: string;
  subItems?: string[];
  /** Optional display-label overrides keyed by ExportCategory value. */
  subItemLabels?: Record<string, string>;
}
